import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://fd22cd5cf17143109ab1d0ca98e8ec7f@sentry.io/121642",

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  // default is 0.
  // replaysSessionSampleRate: 0.1,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  integrations: [
    new Sentry.Replay({
      // Additional SDK configuration goes in here:
      maskAllText: false,
      maskAllInputs: false
    })
  ]
});

const crashReporter = store => next => action => {
  try {
    // Capture actions as breadcrumbs
    Sentry.addBreadcrumb({
      category: "redux",
      message: action.type
    });

    // Catch error actions
    if (action.error) {
      throw action.payload;
    }
  } catch (err) {
    const state = store.getState();

    // Report error to Sentry
    Sentry.configureScope(scope => {
      scope.setUser({
        email: state.auth.getIn(["user", "email"]),
        username: state.auth.getIn(["user", "name"])
      });
    });
    Sentry.captureException(err, { extra: { action, state } });
  }

  // Next middleware
  return next(action);
};

export default crashReporter;
